import { render, staticRenderFns } from "./edit-select-vcard.vue?vue&type=template&id=b806ac04&scoped=true&"
import script from "./edit-select-vcard.vue?vue&type=script&lang=js&"
export * from "./edit-select-vcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b806ac04",
  null
  
)

export default component.exports